export const PAYMENT_LOGO_URL = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/vector/klarna-logo.svg';
export const WORDMARK_LOGO_URL = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/logo/zb-logo-knockout.svg';

export const HOME_URL = 'https://www.zenbusiness.com/';
export const HELP_URL = 'https://help.zenbusiness.com/';
